"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/WhatsNew/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _changelog = require('shared/data/changelog');
var _user = require('shared/selectors/user');
var _whatsNew = require('shared/hooks/whatsNew');

var _hooks = require('web/services/hooks');
var _posthog = require('web/services/posthog'); var _posthog2 = _interopRequireDefault(_posthog);
var _whatsNew3 = require('web/services/whatsNew');
var _TitleTooltip = require('web/components/Sidebar/TitleTooltip'); var _TitleTooltip2 = _interopRequireDefault(_TitleTooltip);



// Electron opens window.open links in the system browser.
const platform = () => (window.ELECTRON ? 'desktop' : 'web')

const Sparkle = () => (
  _react2.default.createElement('svg', { className: "whats-new--sparkle", viewBox: "0 0 16 16"   , width: "14", height: "14", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    , _react2.default.createElement('path', { d: "M8 0c.4 4.2 3.8 7.6 8 8-4.2.4-7.6 3.8-8 8-.4-4.2-3.8-7.6-8-8 4.2-.4 7.6-3.8 8-8Z"           , fill: "currentColor", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}} )
  )
)

const Cross = () => (
  _react2.default.createElement('svg', { viewBox: "0 0 10 10"   , 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
    , _react2.default.createElement('path', { d: "M1.5 1.5l7 7m0-7l-7 7"   , stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}} )
  )
)

/** The signed-in staff user's "What's New" status on this browser. */
 const useMyWhatsNew = () => {
  const userKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const isPatient = _hooks.useAppSelector.call(void 0, _user.selectIsPatientMode)
  return _whatsNew.useWhatsNew.call(void 0, _whatsNew3.whatsNew, userKey, isPatient)
}; exports.useMyWhatsNew = useMyWhatsNew

/* The pill or row: shown until the person opens the public page and then
 * dismisses it; back, without its ×, when a later release is added. */
const useLinkOut = (surface) => {
  const whatsNewState = exports.useMyWhatsNew.call(void 0, )
  const { status, open } = whatsNewState
  const isShown = status === 'unopened' || status === 'opened'
  _react.useEffect.call(void 0, () => {
    if (isShown) _posthog2.default.capture('whats_new_pill_shown', { surface, platform: platform() })
  }, [isShown, surface])
  const onOpen = _react.useCallback.call(void 0, () => {
    _posthog2.default.capture('whats_new_pill_clicked', { surface, platform: platform(), status })
    window.open(_changelog.whatsNewUrl, '_blank', 'noopener')
    open()
  }, [surface, status, open])
  return { ...whatsNewState, isShown, onOpen }
}

/* Above the sidebar's profile footer. Collapsed, a round button above the
 * gear. */
 const WhatsNewPill = ({ isCollapsed }) => {
  const { status, isShown, onOpen, dismiss } = useLinkOut('sidebar')
  if (!isShown) return null
  const canDismiss = status === 'opened'
  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'whats-new--pill-row', isCollapsed && 'is-collapsed'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
      , _react2.default.createElement(_TitleTooltip2.default, { title: isCollapsed ? "What's New" : '', place: "right", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
        , _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'whats-new--pill', canDismiss && 'has-dismiss'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement('button', {
            type: "button",
            className: "whats-new--pill--open",
            'aria-label': isCollapsed ? "What's New" : undefined,
            onClick: onOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}

            , _react2.default.createElement(Sparkle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}} )
            ,  !isCollapsed && _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "What's New" ) 
          )
          ,  canDismiss && (
            _react2.default.createElement('button', {
              type: "button",
              className: "whats-new--pill--dismiss",
              'aria-label': "Hide What's New"  ,
              onClick: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}

              , _react2.default.createElement(Cross, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} )
            )
          )
        )
      )
    )
  )
}; exports.WhatsNewPill = WhatsNewPill

/* Narrow web's form of the pill: a row at the top of Settings, which the
 * Settings tab's amber dot points to until it is opened. */
 const WhatsNewSettingsRow = () => {
  const { status, isShown, onOpen, dismiss } = useLinkOut('settings_row')
  if (!isShown) return null
  return (
    _react2.default.createElement('div', { className: "whats-new--row-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
      , _react2.default.createElement('span', { className: "whats-new--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
        , _react2.default.createElement('button', {
          type: "button",
          className: "whats-new--row--open",
          onClick: onOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}

          , _react2.default.createElement(Sparkle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 102}} )
          , _react2.default.createElement('span', { className: "whats-new--row--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, "What's New" )
          ,  status === 'unopened' && _react2.default.createElement('span', { className: "whats-new--row--chevron", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, "›") 
        )
        ,  status === 'opened' && (
          _react2.default.createElement('button', {
            type: "button",
            className: "whats-new--row--dismiss",
            'aria-label': "Hide What's New"  ,
            onClick: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}

            , _react2.default.createElement(Cross, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 113}} )
          )
        )
      )
    )
  )
}; exports.WhatsNewSettingsRow = WhatsNewSettingsRow
